import { graphQLFetch } from "../../../utils";
import { DELETE_INSPECTION } from "../../queries";

export const deleteInspection =
  ({ inspId, pId, cId }, callback) =>
  async (dispatch, getState) => {
    const variables = {
      inspId,
      pId,
      cId,
    };

    const data = await graphQLFetch(
      DELETE_INSPECTION,
      variables,
      "mutation",
      getState,
      { cacheKeys: ["GetProjInsp"] }
    );
    const { DelInsp } = data || {};
    callback(DelInsp);
  };
